
//  導出功能可以使用 差PI放資料
<template>
  <div>
    <Modal class="editBlock exportcontact" v-model="modal" title="导出联系人" width="35" footer-hide>
      <div class="bodyfirst">
        <div class="title">选择导出的联系人</div>
        <div class="content">
          <RadioGroup v-model="exportcontact" vertical>
            <Radio label="select">
              <span>已选取的联系人 ({{selectarr.length}})</span>
            </Radio>
            <Radio label="all">
              <Dropdown trigger="click">
                  <a href="javascript:void(0)">
                      全部({{totalarr.length}})
                      <Icon type="md-arrow-dropdown" />
                  </a>
                  <DropdownMenu slot="list">
                      <DropdownItem>全部({{totalarr.length}})</DropdownItem>
                      <DropdownItem>客户</DropdownItem>
                      <DropdownItem>合作伙伴</DropdownItem>
                      <DropdownItem>集成商</DropdownItem>
                      <DropdownItem>渠道</DropdownItem>
                      <DropdownItem>供应商</DropdownItem>
                      <DropdownItem>分销商</DropdownItem>
                      <DropdownItem>其他</DropdownItem>
                  </DropdownMenu>
              </Dropdown>
            </Radio>
          </RadioGroup>
        </div>
      </div>
      <div class="bodytwice">
        <div class="title">导出的档案为</div>
          <div class="content">
            <RadioGroup v-model="file" vertical>
              <Radio label="XLS" disabled>
                <span>XLS</span>
              </Radio>
              <Radio label="html" disabled>
                <span>html</span>
              </Radio>
              <Radio label="CSV">
                <span>CSV</span>
              </Radio>
            </RadioGroup>
          </div>
      </div>
      <div class="modal-body-footer">
        <div class="btngp">
          <div class="btn" @click="exportConfirm" >确定</div>
          <div class="btn" @click="file = '',exportcontact='' ">重置</div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "ModalEXport",
  props: ["exportModal","selectarr","totalarr","table"],
  data () {
    return {
      file:'',
      exportcontact:'',
    }
  },
  computed: {
    modal: {
      get () {
        return this.exportModal
      },
      set (val) {
        this.$emit("update:exportModal",val)
      }
    }
  },
  methods: {
    exportConfirm () {
      this.table.exportCsv({
          filename: 'Custom data',
      })
    }
  }
}
</script>
<style lang="less">
.editBlock.exportcontact {
  .ivu-modal-body {
    .content {
      padding:0px 25px 20px 100px;
      span{
        font-size: 15px;
      }
    }
    .ivu-radio-wrapper.ivu-radio-group-item.ivu-radio-default{
      margin-top: 25px;
    }
  }
  .bodyfirst{
    .ivu-dropdown{
      border-radius: 3px;
      border: solid 1px var(--border-black);
      width: 170px;
      .ivu-dropdown-rel{
        padding: 5px 10px;
        font-size: 15px;
        a{
          display: inline-block;
          color: var(--main-black);
          width: 100%;
          position: relative;
          .ivu-icon-md-arrow-dropdown:before{
            display: inline-block;
            position: relative;
            position: absolute;
            right: 0;
            top: 6px;
            font-size: 18px;
          }
        }
      }
      .ivu-dropdown-item{
        padding: 2px 16px;
      }
    }
  }
}
</style>